import { VideoBlock } from "../components/video-block";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_VideoBlock";

const create = (data: { url: string; caption: string }): JSX.Element => {
  const { url, caption } = data;
  return <VideoBlock url={url} caption={caption} />;
};

export default { test, create };
